import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import {MayanHeroes_1Screen} from "../MayanHeroes/game_1Screen";
export class MayanHeroesLink_1Screen extends MayanHeroes_1Screen {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "MayanHeroesLink");
    }
}